<template>
  <div class="form-wrap-code">
    <div class="form">
      <p class="title" style="font-size: 24px">扫码登录</p>
      <div class="content">
        <div class="wrap-code-img">
          <div class="code-img">
            <el-image :src="codeImg">
              <template #error>
                <div class="code-error">
                  <div class="background"></div>
                  <div class="image-slot">
                    <h3 style="text-align: center">二维码已失效</h3>
                    <el-button
                      type="primary"
                      size="small"
                      @click="fetchLoginQrCode"
                      >点击刷新</el-button
                    >
                  </div>
                </div>
              </template>
            </el-image>
          </div>
          <p>微信扫码关注【易猎云】服务号即可登录</p>
        </div>
      </div>
    </div>
    <!-- 短信验证码 -->
    <div class="grey" v-if="handleType == 1">
      <div class="message">
        <el-form>
          <span
            class="ats wlxl ats-icon_close"
            @click="
              () => {
                fetchLoginQrCode();
                handleType = 0; //关闭弹出层
              }
            "
          ></span>
          <p class="title" style="margin: 0; padding: 40px 40px">
            易猎云账号绑定
          </p>
          <el-form-item style="margin: 25px 0 30px">
            <el-input
              v-model="setMobile"
              @input="checkMobile"
              placeholder="请输入手机号"
            />
          </el-form-item>
          <p
            class="warning"
            v-if="
              sqlExis == 2 &&
              /^(13[0-9]|14[01456879]|15[0-35-9]|16[2567]|17[0-8]|18[0-9]|19[0-35-9])\d{8}$/.test(
                setMobile
              ) == true
            "
            style="font-size: 15px"
          >
            当前用户尚未注册，请联系管理员为该手机号创建账号后再进行服务号绑定
          </p>
          <el-form-item
            style="margin-bottom: 22px"
            class="verifiCation"
            v-if="
              sqlExis == 1 &&
              /^(13[0-9]|14[01456879]|15[0-35-9]|16[2567]|17[0-8]|18[0-9]|19[0-35-9])\d{8}$/.test(
                setMobile
              ) == true
            "
          >
            <el-input v-model="setCaptcha" placeholder="请输入验证码" />
            <el-button
              type="primary"
              @click="getMessageCaptcha()"
              v-if="captchaType == false"
              :disabled="
                /^(13[0-9]|14[01456879]|15[0-35-9]|16[2567]|17[0-8]|18[0-9]|19[0-35-9])\d{8}$/.test(
                  setMobile
                ) == false
              "
              :loading="greyLoad"
              >获取验证码</el-button
            >
            <el-button
              style="background: #c8c9cc"
              v-if="captchaType == true"
              disabled
              >{{ timeNum }}秒后重发</el-button
            >
          </el-form-item>
          <el-form-item style="margin-bottom: 0">
            <el-button
              type="primary"
              @click="messageSubmit()"
              :disabled="
                /^(13[0-9]|14[01456879]|15[0-35-9]|16[2567]|17[0-8]|18[0-9]|19[0-35-9])\d{8}$/.test(
                  setMobile
                ) == false || setCaptcha == false
              "
              >账号绑定</el-button
            >
          </el-form-item>
        </el-form>
      </div>
    </div>
  </div>
</template>

<script setup>
import { boo } from "../../../tool/apiboo.js";
import dayjs from "dayjs";
export default {
  name: "CodeLogins",
  data() {
    return {
      tagActive: 1,
      codeImg:
        "https://img.yilieyun.com/ats-speed-version/paginationImages/qrcode.png",
      sceneId: "",
      timeCount: 0,
      tenantId: "",
      newTimes: 0,
      handleType: 0,
      // 0: 默认 1:已入库 2：未入库
      sqlExis: 0,
      setMobile: "",
      setCaptcha: "",
      captchaType: false,
      timeNum: 59,
      timeCountNext: 0,
      greyLoad: false,
    };
  },
  created() {
    this.fetchLoginQrCode();
    this.clearAllInterval();
  },
  methods: {
    async fetchLoginQrCode() {
      try {
        // 重置二维码有效期的定时器
        window.clearInterval(this.newTimes);
        this.newTimes = 0;

        let ret = await this.getLoginQrCode({});
        this.codeImg = ret.qrCodeUrl + "?time=" + dayjs().valueOf();
        // 二维码有效期十分钟（600s）
        let times = 600;
        this.newTimes = window.setInterval(() => {
          if (times > 0) {
            times -= 1;
          } else {
            window.clearInterval(this.newTimes);
            this.newTimes = 0;
            this.codeImg = "";
          }
        }, 1000);
        this.sceneId = ret.sceneId;
        this.tenantId = ret.tenantId;
        this.setIntervalFunction();
      } catch (err) {
        this.codeImg = "";
        console.log(err);
      }
    },
    getLoginQrCode(data) {
      return new Promise((resolve, reject) => {
        const url = `https://officialsiteapi${boo()}.yilieyun.com/siteapi/Apply/getLoginQrCode`;
        let params = new FormData();
        for (const key of Object.keys(data)) {
          params.append(key, data[key]);
        }
        let config = {
          headers: { "Content-Type": "multipart/form-data" },
        };
        this.$axios
          .post(url, params, config)
          .then((response) => {
            if (response.data.code == 200) {
              resolve(response.data.data);
            } else {
              reject(response.data.msg);
            }
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    // 轮询二维码扫描状态
    setIntervalFunction() {
      if (!this.timeCount) {
        this.timeCount = window.setInterval(this.toCheckBinding, 2000);
      }
    },
    async toCheckBinding() {
      try {
        //随机数
        var random = this.randomWord(50, 50);
        localStorage.removeItem("ClientBrowseIds");
        localStorage.setItem("ClientBrowseIds", random);
        let ret = await this.checkBinding({
          sceneId: this.sceneId,
          clientBrowseId: random, //登录时候传随机数
        });

        // 0:默认(用户还未扫码) 1:短信验证 2:跳转首页
        if (ret.handleType != 0) {
          this.clearAllInterval();
          this.timeCount = 0;
        }
        if (ret.handleType == 1) {
          // 绑定手机号弹窗
          this.handleType = 1;
        } else if (ret.handleType == 2) {
          this.goToHome(ret.userLoginInfo);
        }
      } catch (err) {
        // if(err.indexOf('停用')>-1){
          this.fetchLoginQrCode()
          return this.$message({
            duration: 1000,
            message: err,
            type: "error",
            center: true,
            customClass: "loginCustomClass",
          });
        // }else{
        //   console.log("Err",err)
        // }
      }
    },
    checkBinding(data) {
      return new Promise((resolve, reject) => {
        const url = `https://officialsiteapi${boo()}.yilieyun.com/siteapi/Apply/checkBinding`;
        this.$axios
          .get(
            url +
              "?sceneId=" +
              data.sceneId +
              "&clientBrowseId=" +
              data.clientBrowseId
          )
          .then((response) => {
            if(response.data.msg.indexOf('停用')>-1){
              this.clearAllInterval()
              this.timeCount = 0
              reject(response.data.msg);
            }else{
              resolve(response.data.data);
            }
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    //检验手机号是否入库
    async checkMobile() {
      this.sqlExis = 0;
      try {
        if (
          /^(13[0-9]|14[01456879]|15[0-35-9]|16[2567]|17[0-8]|18[0-9]|19[0-35-9])\d{8}$/.test(
            this.setMobile
          )
        ) {
          let ret = await this.phoneCheck({
            tenantId: this.tenantId,
            phone: this.setMobile,
          });
          if (ret === 1) {
            this.sqlExis = 1;
          } else {
            this.sqlExis = 2;
          }
        }
      } catch (err) {
        this.sqlExis = 0;
        console.log(err);
      }
    },
    phoneCheck(data) {
      return new Promise((resolve, reject) => {
        const url = `https://officialsiteapi${boo()}.yilieyun.com/siteapi/Apply/phoneCheck`;
        this.$axios
          .get(url + "?phone=" + data.phone)
          .then((response) => {
            var datas;
            if (response.data.code == 200) {
              datas = 1;
            } else {
              datas = 2;
            }
            resolve(datas);
          })
          .catch((error) => {
            console.log("error", error);
            reject(error);
          });
      });
    },
    // 随机生成字母数字组成的字符
    randomWord(min, max) {
      var returnStr = "",
        range = max ? Math.round(Math.random() * (max - min)) + min : min,
        charStr =
          "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";

      for (var i = 0; i < range; i++) {
        var index = Math.round(Math.random() * (charStr.length - 1));
        returnStr += charStr.substring(index, index + 1);
      }
      return returnStr;
    },
    // 获取短信验证码
    async getMessageCaptcha() {
      try {
        this.greyLoad = true;
        await this.sendSmsVerifyCode({
          type: 3,
          phone: this.setMobile,
        });
        this.greyLoad = false;
        this.captchaType = true;
        //短信验证码-60s倒计时开始
        this.timeCountNext = window.setInterval(() => {
          if (this.timeNum > 0) {
            this.timeNum -= 1;
          } else {
            window.clearInterval(this.timeCountNext);
            this.timeCountNext = 0;
            this.captchaType = false;
            this.timeNum = 59;
          }
        }, 1000);
      } catch (err) {
        console.log(err);
      }
    },
    sendSmsVerifyCode(data) {
      return new Promise((resolve, reject) => {
        const url = `https://officialsiteapi${boo()}.yilieyun.com/siteapi/Apply/sendTransferNote`;
        let params = new FormData();
        for (const key of Object.keys(data)) {
          params.append(key, data[key]);
        }
        let config = {
          headers: { "Content-Type": "multipart/form-data" },
        };
        this.$axios
          .post(url, params, config)
          .then((response) => {
            if (response.data.code == 200) {
              resolve(response.data.data);
            } else {
              reject(response.data.msg);
            }
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    // 账号绑定
    async messageSubmit() {
      try {
        //随机数
        var random = this.randomWord(50, 50);
        localStorage.removeItem("ClientBrowseIds");
        localStorage.setItem("ClientBrowseIds", random);
        let ret = await this.verifyCodeCheck({
          sceneId: this.sceneId,
          phone: this.setMobile,
          verifyCode: this.setCaptcha,
          clientBrowseId:random
        });
        this.goToHome(ret.userLoginInfo);
        // ElMessage.success('手机号绑定成功')
        return this.$message({
          message: "手机号绑定成功",
          type: "success",
          center: true,
          customClass: "loginCustomClass",
        });
      } catch (err) {
        console.log(err);
        return this.$message({
          duration: 1000,
          message: err,
          type: "error",
          center: true,
          customClass: "loginCustomClass",
        });
      }
    },
    verifyCodeCheck(data) {
      return new Promise((resolve, reject) => {
        const url = `https://officialsiteapi${boo()}.yilieyun.com/siteapi/Apply/verifyCodeCheck`;
        let params = new FormData();
        for (const key of Object.keys(data)) {
          params.append(key, data[key]);
        }
        let config = {
          headers: { "Content-Type": "multipart/form-data" },
        };
        this.$axios
          .post(url, params, config)
          .then((response) => {
            if (response.data.code == 200) {
              resolve(response.data.data);
            } else {
              reject(response.data.msg);
            }
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    // userinfo存储，跳转首页
    async goToHome(userInfo) {
      console.log(userInfo);
      this.clearAllInterval();
      var cbid= localStorage.getItem("ClientBrowseIds", "");
        console.log(userInfo,"用户信息");
        console.log(cbid,"登录id");
        userInfo.ClientBrowseId=cbid;
        console.log("https://" + domanUrl + "#/jump/?userinfo=" + JSON.stringify(userInfo),"跳转地址");
      // 身份信息注入，跳转极速版首页
      const domanUrl = userInfo.profile.domain;
      window.open(
        "https://" + domanUrl + "#/jump/?userinfo=" + JSON.stringify(userInfo)
      );
      //隐藏弹框
      // this.close()
      this.$emit("cloesAll");
      zhuge.track("登录", {
        租户:userInfo.profile.tenantName,
        分类: "扫码登录",
        入口: "官网",
        客户类型:userInfo.profile.clientClassify
      });
     
    },
    // 清除所有的定时器
    clearAllInterval() {
      let end = window.setInterval(() => {}, 10000);
      for (let i = 1; i <= end; i++) {
        window.clearInterval(i);
      }
    },
  },
};
</script>

<style lang="less" scoped>
.form-wrap-code {
  position: fixed;
  top: 105px;
  // left: 1180px;
  // transform: translate(745px);
  z-index: 9999;
  width: 458px;
  background: #ffffff;
  box-shadow: 0px 2px 16px 0px #a5c6ed;
  user-select: none;
  // margin-right: 10%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: 32px 60px 50px;
  border-radius: 8px;
  .el-form-item__content {
  }
  .title {
    font-size: 30px !important;
    color: #333333;
    padding: 40px 40px;
    margin: 0;
    text-align: center;
  }
  .wrap-code-img {
    --el-color-primary-light-3: #5666ff !important;
    --el-color-primary-dark-2: #5666ff !important;
    position: relative;
    top: -12px;

    .el-image {
      width: 216px;
      height: 216px;
    }
    .code-img {
      display: flex;
      justify-content: center;
      .code-error {
        width: 216px;
        height: 216px;
        position: relative;
        .background {
          width: 100%;
          height: 100%;
          background-image: url("https://img.yilieyun.com/ats-speed-version/paginationImages/qrcode.png");
          background-size: 100% 100%;
          opacity: 0.2;
        }
        .image-slot {
          position: absolute;
          top: 0;
          display: flex;
          flex-direction: column;
          justify-content: center;
          width: 100%;
          height: 100%;
          background-color: rgb(255 255 255 / 80%);
          h3 {
            font-weight: 400;
          }

          .el-button {
            width: 70px;
            margin: 20px auto 0;
            background: #5666ff;
          }
        }
      }

      p {
        font-size: 14px;
        color: #333333;
        text-align: center;
        margin-top: 14px;
      }
    }
    p {
      text-align: center;
      font-size: 16px;
      margin-top: 37px;
    }
  }

  .grey {
    // display: flex;
    // justify-content: center;
    // flex-direction: column;
    // align-items: flex-end;
    position: absolute;
    top: 0px;
    left: 0;
    // left: 0px;
    // width: 100%;
    // height: 100%;
    // background-color: rgb(12 12 12 / 20%);
    // opacity: 0.4;
    z-index: 1;
    .message {
      position: relative;
      height: 410px;
      width: 458px;
      display: flex;
      flex-direction: column;
      justify-content: center;
      background-color: #ffffff;
      border-radius: 2px;
      padding: 32px 60px 50px;
      .el-form {
        // margin: 0 50px;
        width: revert;
        height: inherit;
        .ats-icon_close {
          color: #5666ff;
          font-size: 20px;
          cursor: pointer;
          position: absolute;
          top: 0px;
          right: 0;
          padding: 10px;
        }
        .warning {
          font-size: 14px;
          color: #fd0202;
          text-align: left;
          margin-top: 0px;
        }
        p {
          font-size: 26px;
          color: #333333;
          margin: 40px 0 33px;
        }
        .verifiCation {
          .el-input {
            width: 58%;
          }

          .el-button {
            width: 40%;
            margin: 0;
          }
        }
      }
    }
  }

  .el-button {
    width: 100%;
    // margin: 30px 0 0;
    background: #5666ff;
    color: #ffffff;
    height: 54px;
    font-size: 16px;
  }

  .is-disabled {
    background-color: #7a8193 !important;
  }
}
</style>
<style>
.form-wrap-code .el-form-item .el-input__inner {
  height: 54px !important;
  line-height: 54px !important;
  font-size: 18px !important;
}
</style>



// WEBPACK FOOTER //
// src/components/views/login/code.vue